export type AdjacentResultsDirection = 'more' | 'previous';

// Load More and Load Previous share one LoadableState, so the direction rides
// on the error itself to tell the two failures apart.
export default class AdjacentResultsError extends Error {
  direction: AdjacentResultsDirection;

  constructor(direction: AdjacentResultsDirection, error: Error) {
    super(error.message);

    this.direction = direction;
    this.name = 'AdjacentResultsError';
    this.stack = error.stack;
  }
}

export function getAdjacentResultsErrorDirection(
  error: Error | undefined
): AdjacentResultsDirection | undefined {
  return error instanceof AdjacentResultsError ? error.direction : undefined;
}
